export default {
  toasts: {
    load_error: 'Gebyrsatserne kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  rates: {
    title: 'Behandlingsmargin',
    description:
      'Procent i %, plus et valgfrit fast beløb og minimumsbeløb pr. betaling. „Enhver betalingsmetode“ gælder, når der ikke findes en metodespecifik sats.',
  },
};
